import type { Section } from '@common/formEngine/formEngine.types';
import type { IPatientContactDetails } from '@common/interfaces/patientContactDetails';
import type { HolterExaminationRequest } from './hollterRequestsSchemas';
import type { HolterExaminationRequestContentKeys } from './holterExaminationRequestSchemas';
import type { HolterExaminationRequestAdvice, HolterExaminationRequestBase, HolterReferralData } from './utils/utils';
import { type PatientAlternativeAddressType } from '../../patientContactDetailsSchema';
import {
    holterAnamnesisSection,
    holterHistorySection,
    holterRustEcgSection,
    medicationSection,
} from './hollterRequestsSchemas';
import {
    adviceSection,
    diagnosisSection,
    holteReferralSection,
    holterRiskFactorsSection,
    holterSetupSection,
    patientAddressSection,
    professionalSummarySection,
} from './holterExaminationRequestSchemas';

export type HolterHomeExaminationRequestData = HolterExaminationRequestBase &
    PatientAlternativeAddressType &
    HolterReferralData &
    HolterExaminationRequestAdvice & {
        patient: IPatientContactDetails;
    };

export const holterHomeExaminationRequestSections: Section<
    HolterHomeExaminationRequestData,
    HolterExaminationRequestContentKeys,
    HolterExaminationRequest
>[] = [
    holteReferralSection,
    holterSetupSection,
    holterAnamnesisSection,
    holterRustEcgSection,
    holterHistorySection,
    medicationSection,
    adviceSection,
    holterRiskFactorsSection,
    professionalSummarySection,
    diagnosisSection,
    patientAddressSection,
];
